import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  standalone: false,
})
export class ErrorPageComponent implements OnInit {
  @Input() public errorCode: string;

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.errorCode = this.errorCode ? this.errorCode : this.activatedRoute.snapshot.paramMap.get('errorCode');
  }
}
